import {Component, OnInit} from '@angular/core';
import {TenantsService} from "./tenants.service";
import {ViewManagerService} from "../../services/view-manager.service";
import {Level, Message} from "../../model/message.component";
import {Space} from "../../model/tenants.model";

@Component({
  selector: 'app-tenants',
  templateUrl: './tenants.component.html',
  styleUrls: ['./tenants.component.css']
})
export class TenantsComponent implements OnInit {

  constructor(
    private tenantsService: TenantsService,
    private viewManager: ViewManagerService
  ) {
  }

  ngOnInit(): void {
    this.tenantsService.loadSpaces();
  }

  getUsers() {
    return this.tenantsService.users;
  }

}
